import { baseRequest } from '@/lib/base';

// Snapshot the authenticated customer's active cart into a reusable draft.
// The backend marks the active cart as checked out on success.
export const saveCartAsOrder = () => baseRequest({
    url: '/order/saved-orders/',
    method: 'POST',
    body: {},
});

export const fetchSavedOrders = () => baseRequest({
    url: '/order/saved-orders/',
});

export const fetchSavedOrder = (uuid: string) => baseRequest({
    url: `/order/saved-orders/${uuid}/`,
});

export const deleteSavedOrder = (uuid: string) => baseRequest({
    url: `/order/saved-orders/${uuid}/`,
    method: 'DELETE',
});

// Turn a draft into a pending order; the backend deletes the draft on success.
export const convertSavedOrder = (uuid: string) => baseRequest({
    url: `/order/saved-orders/${uuid}/convert/`,
    method: 'POST',
    body: {},
});

// Quick order: create a new pending order from an existing order's items,
// repriced against current product data.
export const reorderOrder = (uuid: string) => baseRequest({
    url: `/order/orders/${uuid}/reorder/`,
    method: 'POST',
    body: {},
});
